<script>
import { mapActions } from 'vuex/dist/vuex.common.js';

export default {
    props: {
        Id: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            data: null,
        }
    },

    computed: {
        HEADERS() {
            return [
                'name',
                'value',
            ];
        },
    },

    mounted() {
        this._getOtherRelations();
    },

    methods: {
        ...mapActions('documents', ['getOtherRelations']),

        _getOtherRelations() {
            this.getOtherRelations(this.Id)
                .then(res => {
                    this.data = res.data.value;
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        },

        HandleClickItem(item, key) {
            if (Object.prototype.hasOwnProperty.call(item, 'defra_category_id')) {
                const carbon_endpoint = process.env.VUE_APP_CARBON_DOMAIN;
                window.open(`${carbon_endpoint}/ghg-emission-details?c=${item.defra_category_id}&i=${item.id}`);
            } else if (key.includes('category')) {
                const carbon_endpoint = process.env.VUE_APP_CARBON_DOMAIN;
                const [main, sub] = item.sub_category_number.split('.');
                window.open(`${carbon_endpoint}/category-${main}-details?c=${sub}&i=${item.id}`);
            } else {
                const route = this.$router.resolve({path: '/kpi-metrics', query: { 
                    category: item.sust_category_id,
                    element: item.sust_element_id,
                    target: item.sust_target_id,
                    kpi: item.sust_kpi_id,
                    metric: item.sust_metric_kpi_id,
                }});
                window.open(route.href, '_blank');
            }
        }
    }
}
</script>

<template>
    <div class="document-relations">
        <div v-if="data">
            <div v-for="(value, key, index) in data" :key="key">
                <div class="title" :style="{'border-top': index === 0 ? 0 : null}">
                    {{ $t(`documents.relations.titles.${key}`) }}
                </div>

                <div class="header">
                    <div v-for="header in HEADERS" :key="header">
                        {{ $t(`documents.relations.headers.${header}`) }}
                    </div>
                </div>
                <div class="items" v-for="(item, idx) in value" :key="idx" @click="HandleClickItem(item, key)">
                    <div v-for="header in HEADERS" :key="header">
                        {{ item[header] }}
                    </div>
                </div>

                <div v-if="value == null || value.length === 0" style="padding-top: .5em; color: darkgray;">
                    {{ $t('documents.relations.nothing_related') }}
                </div>
            </div>
        </div>

        <div v-else>
            An error occurred when trying to fetch the details!
        </div>
    </div>
</template>

<style lang='scss' scoped>
    .document-relations {
        padding: .1em;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        > div {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: stretch;
            
            > div {
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                text-align: left;
                margin: 1em 2.5%;

                > .title {
                    width: 100%;
                    border-top: thin solid black;
                    margin-bottom: .25em;
                    font-size: 1.25vw;
                    font-weight: bold;
                    color: black;
                }

                > .items,.header {
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: flex-start;

                    border-bottom: thin solid lightgray;

                    > div {
                        flex: 1;
                    }
                }
                
                > .header {
                    border-bottom-color: thin solid gray;
                    font-weight: bold;
                }

                > .items {
                    border-bottom-color: lightgray;

                    &:last-of-type {
                        border-bottom: 0;
                    }

                    cursor: pointer;
                    transition: background-color 250ms;

                    &:hover {
                        background-color: rgba(0, 0, 0, 0.1);
                    }
                }

            }
        }
    }
</style>